




































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import PicView from "@/components/pic-preview.vue";
@Component({
  components: {
    PicView,
  },
})
export default class SzsxDuoxuan extends Vue {
  @Prop()
  private question;
  @Prop()
  private index;
  @Prop()
  private filters;
  private get answer() {
    return this.$store.state.moniAnswers[this.index];
  }
  private ifShowPic: boolean = false;
  private index2Alpha: any[] = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
  ];
  /**
   * @description 选择一项
   */
  private selectThis(oi) {
    this.$emit("select", oi);
  }
  /**
   * @description 判断是否被选中
   */
  private ifSelected(oi) {
    if (!this.answer || !this.answer["reply"]) {
      return false;
    }
    const inx = this.answer["reply"].indexOf(oi);
    if (inx !== -1) {
      return true;
    } else {
      return false;
    }
  }
}
